import { render, staticRenderFns } from "./NuevosIngresosTabContent.vue?vue&type=template&id=0d090868&scoped=true"
import script from "./NuevosIngresosTabContent.vue?vue&type=script&lang=js"
export * from "./NuevosIngresosTabContent.vue?vue&type=script&lang=js"
import style0 from "./NuevosIngresosTabContent.vue?vue&type=style&index=0&id=0d090868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d090868",
  null
  
)

export default component.exports